export default __webpack_public_path__ + "static/media/control-5-white.291e2c76.svg";